// API helper for InfoPoint Balkans backend
const API = process.env.REACT_APP_BACKEND_URL;

const json = (res) => {
  if (!res.ok) return res.text().then((t) => { throw new Error(t || `API ${res.status}`); });
  return res.json();
};

const post = (path, body, headers = {}) =>
  fetch(`${API}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify(body),
  }).then(json);

const authHeaders = () => {
  try {
    const t = localStorage.getItem('ipa_admin_token');
    return t ? { Authorization: `Bearer ${t}` } : {};
  } catch { return {}; }
};

export const api = {
  countries: () => fetch(`${API}/api/countries`).then(json),
  cities: (country) => fetch(`${API}/api/cities${country ? `?country=${country}` : ''}`).then(json),
  businesses: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return fetch(`${API}/api/businesses${qs ? `?${qs}` : ''}`).then(json);
  },
  business: (id) => fetch(`${API}/api/businesses/${id}`).then(json),
  tours: (country) => fetch(`${API}/api/tours${country ? `?country=${country}` : ''}`).then(json),

  chat: (sessionId, message) => post('/api/ai/chat', { session_id: sessionId, message }),
  chatHistory: (sessionId) => fetch(`${API}/api/ai/history/${sessionId}`).then(json),

  // Monetization (plans + Stripe checkout)
  plans: () => fetch(`${API}/api/plans`).then(json),
  checkout: (payload) => post('/api/payments/checkout', payload),
  paymentStatus: (sessionId) => fetch(`${API}/api/payments/status/${sessionId}`).then(json),

  // Advertising engine (one-time featured/sponsored campaigns)
  adPackages: () => fetch(`${API}/api/ads/packages`).then(json),
  adCheckout: (payload) => fetch(`${API}/api/ads/checkout`, {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  }).then(json),
  myCampaigns: () => fetch(`${API}/api/ads/campaigns/mine`, { credentials: 'include' }).then(json),

  // In-app notifications
  notifications: () => fetch(`${API}/api/notifications`, { credentials: 'include' }).then(json),
  notificationsUnread: () => fetch(`${API}/api/notifications/unread-count`, { credentials: 'include' }).then(json),
  notificationRead: (id) => fetch(`${API}/api/notifications/read/${id}`, { method: 'POST', credentials: 'include' }).then(json),
  notificationsReadAll: () => fetch(`${API}/api/notifications/read-all`, { method: 'POST', credentials: 'include' }).then(json),

  // Lead capture
  claim: (payload) => post('/api/claim', payload),
  booking: (payload) => post('/api/bookings', payload),
  contactLead: (payload) => post('/api/contact-leads', payload),
  reviewCreate: (payload) => post('/api/reviews', payload),
  reviewList: (businessId) => fetch(`${API}/api/reviews/${businessId}`).then(json),

  // Admin
  admin: {
    login: (username, password) => post('/api/admin/login', { username, password }),
    logout: () => post('/api/admin/logout', {}, authHeaders()),
    me: () => fetch(`${API}/api/admin/me`, { headers: authHeaders() }).then(json),
    leads: (params = {}) => {
      const qs = new URLSearchParams(params).toString();
      return fetch(`${API}/api/admin/leads${qs ? `?${qs}` : ''}`, { headers: authHeaders() }).then(json);
    },
    stats: () => fetch(`${API}/api/admin/stats`, { headers: authHeaders() }).then(json),
    updateLead: (leadType, leadId, status) =>
      fetch(`${API}/api/admin/leads/${leadType}/${leadId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ status }),
      }).then(json),
    deleteLead: (leadType, leadId) =>
      fetch(`${API}/api/admin/leads/${leadType}/${leadId}`, { method: 'DELETE', headers: authHeaders() }).then(json),
    payments: () => fetch(`${API}/api/admin/payments`, { headers: authHeaders() }).then(json),
  },
};
